import Head from "next/head";

import config from "config";

import NewProjectLayout from "modules/projects/elements/New-Project-Entitlement-Wrapper";

import CreateTimeSeriesAnalysis from "flows/time-series/views/create-project";

const CreateProject = () => {
  return (
    <>
      <Head>
        <title>
          {config.SITE_NAME} | Create New Time Series Analysis Project
        </title>
      </Head>
      <CreateTimeSeriesAnalysis />
    </>
  );
};

CreateProject.getLayout = (page) => <NewProjectLayout>{page}</NewProjectLayout>;

export default CreateProject;
